<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex'

  import 'waypoints/lib/noframework.waypoints'

  /**
   * Share Partial
   */

  export default {
    name: 'scroll-spy',
    data() {
      return {
        offset: '50%',
        sections: [],
      }
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
      global.Waypoint.destroyAll()
      this.setCurrentIndex(-1)
      this.hide()
    },
    methods: {
      initialize() {
        let sections = this.$el.querySelectorAll('.js-scroll-spy-section')

        this.sections = [].map.call(sections, (section, i) => {
          let o = {
            $el: section,
            label: section.getAttribute('data-label'),
            index: i,
          }

          section.setAttribute('id', `section-${i}`)

          return o
        })
      },
      getLabels() {
        return this.sections.map((section) => {
          return section.label
        })
      },
      watch() {
        this.initialize()
        

        this.sections.forEach((section) => {
          // eslint-disable-next-line no-new
          new global.Waypoint({
            element: section.$el,
            handler: (direction) => {
              if(direction === 'down') {
                this.setCurrentIndex(section.index)

                if(section.index === 0) {
                  this.show()
                }
              }

              if(direction === 'up') {
                let index = section.index - 1
                this.setCurrentIndex(index)
                
                if(index < 0) {
                  this.hide()
                }
              }
            },
            offset: this.offset
          })
        })

        new global.Waypoint({
          element: document.body,
          handler: (direction) => {
            if(direction === 'down') {
              this.hide()
            }

            if(direction === 'up') {
              this.show()
            }
          },
          offset: () => {
            return this.$window.height - document.body.clientHeight
          }
        })
      },
      ...mapMutations({
        'show': 'pageNavigation/SHOW',
        'hide': 'pageNavigation/HIDE',
        'setCurrentIndex': 'pageNavigation/SET_CURRENT_INDEX',
      })
    },
  }
</script>



// WEBPACK FOOTER //
// src/plugins/scroll-spy/scroll-spy.vue